import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { imageForSaving, isEmail } from '../../../../utils/utils';
import * as api from '../../../../services/api';
import LoadingWidget from '../../../widgets/LoadingWidget/LoadingWidget';
import '../../../presenters/renewals/UnauthedRenewalPage/UnauthedRenewalPage.css';
import * as RenewalStatus from '../../../../constants/RenewalStatus';
import CustomerSignaturePage from '../../../presenters/renewals/CustomerSignaturePage/CustomerSignaturePage';
import { THANK_YOU_URL } from '../../../../route-names';

const validators = [
  {
    name: 'signatureImage',
    validate: (state) =>
      !!state.renewalSignature.signatureImage &&
      state.renewalSignature.signatureImage.length > 0
  },
  {
    name: 'fullName',
    validate: (state) =>
      !!state.renewalSignature.fullName &&
      state.renewalSignature.fullName.length > 0
  },
  {
    name: 'email',
    validate: (state) =>
      !!state.renewalSignature.email && isEmail(state.renewalSignature.email)
  }
];

class CustomerSignaturePageWrapper extends PureComponent {
  constructor(props) {
    super(props);

    const { renewal, customer, key, logo } = props.location.state;

    this.state = {
      loading: true,
      renewal,
      customer,
      key,
      logo,
      renewalSignature: {
        signatureImage: renewal.customerSignatureImage || '',
        fullName: renewal.customerApproverName || '',
        email: renewal.customerEmail || ''
      },
      invalidFields: ['signatureImage', 'fullName', 'email']
    };

    this.getOnChangeHandler = this.getOnChangeHandler.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.canSubmit = this.canSubmit.bind(this);
    this.isMutable = this.isMutable.bind(this);
    this.validateFields = this.validateFields.bind(this);
    this.isCompleted = this.isCompleted.bind(this);
  }

  componentDidMount() {
    this.setState({ loading: false });
    this.validateFields();
  }

  getOnChangeHandler(key, transform = (i) => i) {
    return (updatedValue) =>
      this.setState(
        {
          renewalSignature: {
            ...this.state.renewalSignature,
            [key]: transform(updatedValue)
          }
        },
        this.validateFields
      );
  }

  validateFields() {
    const invalidFields = validators
      .filter((validator) => !validator.validate(this.state))
      .map((validator) => validator.name);

    this.setState({
      invalidFields
    });
  }

  onSubmit() {
    this.setState(
      {
        loading: true
      },
      () =>
        api.renewals
          .signBySecret(this.state.key, this.state.renewalSignature)
          .then(() =>
            this.props.history.push({
              pathname: `${THANK_YOU_URL}`,
              state: {
                logo: this.state.logo
              }
            })
          )
          .catch((err) => alert('Error updating renewal: ' + err))
          .then(() =>
            this.setState({
              loading: false
            })
          )
    );
  }

  canSubmit() {
    return this.isMutable() && this.state.invalidFields.length === 0;
  }

  isMutable() {
    return !this.isCompleted();
  }

  isCompleted() {
    return this.state.renewal.status === RenewalStatus.COMPLETED.name;
  }

  render() {
    return this.state.loading ? (
      <LoadingWidget />
    ) : (
      <CustomerSignaturePage
        customer={this.state.customer}
        renewal={this.state.renewal}
        renewalSignature={this.state.renewalSignature}
        onSignatureChange={this.getOnChangeHandler(
          'signatureImage',
          imageForSaving
        )}
        onFullNameChange={this.getOnChangeHandler('fullName')}
        onEmailChange={this.getOnChangeHandler('email')}
        onSubmit={this.onSubmit}
        canSubmit={this.canSubmit()}
        enabled={this.isMutable()}
        invalidFields={this.state.invalidFields}
        logo={this.state.logo}
      />
    );
  }
}

export default withRouter(CustomerSignaturePageWrapper);
